import MyProfile from "../../components/admin/my-profile"

const MyProfilePage = () => {
    return <MyProfile />;
}

export default MyProfilePage;